import {
  gridSizeMdLg12, texto,
  TipoServicioEnumChoice,
  gridSizeConst5, CANTIDAD_CHOICE, gridSizeConst3, CUOTAS_CHOICE, gridSizeConst1,
  SystemParametersEnum
} from "@/shared"
import {
  TabTextLabel, CustomAutocompleteArrString, CustomTextArea,
  SampleCheckbox
} from "@/shared/components/ui"
import {
  AlertSeverityEnum,
} from "@/shared/interfaces"
import { Visibility } from "@mui/icons-material"
import { Grid, IconButton } from "@mui/material"
import { UseFormReturn } from "react-hook-form"
import ModalCuotas from "../modal_cuotas/ModalCuotas"
import { useEquiposAdicionales } from "@/store/erp"
import { useUiStore } from "@/store/ui"
import { IPreventaPymesForm } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface"

interface TabOtrosCargosPreventaProps {
  editSupervisor: boolean
  form: UseFormReturn<IPreventaPymesForm, any, IPreventaPymesForm>
}

export default function TabOtrosCargosPreventaPymes({
  editSupervisor,
  form,
}: TabOtrosCargosPreventaProps) {

  const {
    control,
    reset,
    formState: { errors }
  } = form

  const getDataProducto = useEquiposAdicionales((s) => s.getDataProducto);
  const setAlert = useUiStore(s => s.setAlert)

  return (
    <>
      <Grid container spacing={3}>

        <Grid
          item
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          {...gridSizeMdLg12}
        >
          <TabTextLabel
            text={texto.equipo_adicional}
            mt={0}
            pb={0}
            pl={0}
            pt={2}
          />
        </Grid>

        <Grid
          item
          container
          spacing={2}
          {...gridSizeMdLg12}
          justifyContent={"space-between"}
        >
          <SampleCheckbox
            disabled={
              form.getValues().tipo_servicio == TipoServicioEnumChoice.RADIO
            }
            //disabled={false}
            size={gridSizeConst5}
            label="ROUTER AC"
            control={control}
            name="es_router_ac"
            defaultValue={form.getValues().es_router_ac || false}
            onChangeValue={(e) => {
              reset({ ...form.getValues(), es_router_ac: e });

              if (!e)
                reset({
                  ...form.getValues(),
                  numero_cantidad_router_ac: 0,
                  numero_cuotas_router_ac: 0,
                });
            }}
          />
          {form.getValues().es_router_ac && (
            <>
              <CustomAutocompleteArrString
                disabled={
                  form.getValues().tipo_servicio ==
                  TipoServicioEnumChoice.RADIO
                }
                label="Cant."
                name="numero_cantidad_router_ac"
                options={CANTIDAD_CHOICE}
                control={form.control}
                defaultValue={
                  form.getValues().numero_cantidad_router_ac || ""
                }
                error={errors.numero_cantidad_router_ac}
                helperText={
                  errors.numero_cantidad_router_ac?.message?.toString() ??
                  ""
                }
                isLoadingData={false}
                size={gridSizeConst3}
              />

              <CustomAutocompleteArrString
                disabled={
                  form.getValues().tipo_servicio ==
                  TipoServicioEnumChoice.RADIO
                }
                label="Cuotas"
                name="numero_cuotas_router_ac"
                options={CUOTAS_CHOICE}
                control={form.control}
                defaultValue={
                  form.getValues().numero_cuotas_router_ac || ""
                }
                error={errors.numero_cuotas_router_ac}
                helperText={
                  errors.numero_cuotas_router_ac?.message?.toString() ?? ""
                }
                isLoadingData={false}
                size={gridSizeConst3}
              />

              <Grid item {...gridSizeConst1}>
                <IconButton
                  onClick={() => {
                    if (
                      form.getValues().tipo_servicio ==
                      TipoServicioEnumChoice.RADIO
                    )
                      return setAlert(
                        true,
                        "El valor del equipo está incluido en el valor de instalación para el servicio de RADIO.",
                        AlertSeverityEnum.info
                      );

                    getDataProducto({
                      slug: SystemParametersEnum.ROUTER_AC,
                      cantidad:
                        form.getValues().numero_cantidad_router_ac ?? 0,
                      cuotas: form.getValues().numero_cuotas_router_ac ?? 0,
                    });
                  }}
                >
                  <Visibility />
                </IconButton>
              </Grid>
            </>
          )}
        </Grid>

        <Grid
          item
          container
          spacing={2}
          {...gridSizeMdLg12}
          justifyContent={"space-between"}
        >
          <SampleCheckbox
            size={gridSizeConst5}
            label="WIFI 6"
            control={control}
            name="requiere_wifi_6"
            defaultValue={form.getValues().requiere_wifi_6 || false}
            onChangeValue={(e) => {
              reset({ ...form.getValues(), requiere_wifi_6: e });

              if (!e)
                reset({
                  ...form.getValues(),
                  numero_cuotas_wifi_6: 0,
                  numero_cantidad_wifi_6: 0,
                });
            }}
          />
          {form.getValues().requiere_wifi_6 && (
            <>
              <CustomAutocompleteArrString
                label="Cant."
                name="numero_cantidad_wifi_6"
                options={CANTIDAD_CHOICE}
                control={form.control}
                defaultValue={form.getValues().numero_cantidad_wifi_6 || ""}
                error={errors.numero_cantidad_wifi_6}
                helperText={
                  errors.numero_cantidad_wifi_6?.message?.toString() ?? ""
                }
                isLoadingData={false}
                size={gridSizeConst3}
              />

              <CustomAutocompleteArrString
                label="Cuotas"
                name="numero_cuotas_wifi_6"
                options={CUOTAS_CHOICE}
                control={form.control}
                defaultValue={form.getValues().numero_cuotas_wifi_6 || ""}
                error={errors.numero_cuotas_wifi_6}
                helperText={
                  errors.numero_cuotas_wifi_6?.message?.toString() ?? ""
                }
                isLoadingData={false}
                size={gridSizeConst3}
              />

              <Grid item {...gridSizeConst1}>
                <IconButton
                  onClick={() => {
                    getDataProducto({
                      slug: SystemParametersEnum.WIFI_6,
                      cantidad: form.getValues().numero_cantidad_wifi_6 ?? 0,
                      cuotas: form.getValues().numero_cuotas_wifi_6 ?? 0,
                    });
                  }}
                >
                  <Visibility />
                </IconButton>
              </Grid>
            </>
          )}
        </Grid>

        <Grid
          item
          container
          spacing={2}
          {...gridSizeMdLg12}
          justifyContent={"space-between"}
        >
          <SampleCheckbox
            size={gridSizeConst5}
            label="MINI UPS"
            control={control}
            name="es_ups"
            defaultValue={form.getValues().es_ups || false}
            onChangeValue={(e) => {
              reset({ ...form.getValues(), es_ups: e });
              if (!e)
                reset({
                  ...form.getValues(),
                  numero_cuotas_ups: 0,
                  numero_cantidad_ups: 0,
                });
            }}
          />
          {form.getValues().es_ups && (
            <>
              <CustomAutocompleteArrString
                label="Cant."
                name="numero_cantidad_ups"
                options={CANTIDAD_CHOICE.filter((e) => +e <= 3)}
                control={form.control}
                defaultValue={form.getValues().numero_cantidad_ups || ""}
                error={errors.numero_cantidad_ups}
                helperText={
                  errors.numero_cantidad_ups?.message?.toString() ?? ""
                }
                isLoadingData={false}
                size={gridSizeConst3}
              />

              <CustomAutocompleteArrString
                label="Cuotas"
                name="numero_cuotas_ups"
                options={[24]}
                control={form.control}
                defaultValue={form.getValues().numero_cuotas_ups || ""}
                error={errors.numero_cuotas_ups}
                helperText={
                  errors.numero_cuotas_ups?.message?.toString() ?? ""
                }
                isLoadingData={false}
                size={gridSizeConst3}
              />

              <Grid item {...gridSizeConst1}>
                <IconButton
                  onClick={() => {
                    getDataProducto({
                      slug: SystemParametersEnum.MINI_UPS,
                      cantidad: form.getValues().numero_cantidad_ups ?? 0,
                      cuotas: form.getValues().numero_cuotas_ups ?? 0,
                    });
                  }}
                >
                  <Visibility />
                </IconButton>
              </Grid>
            </>
          )}
        </Grid>

        {form.getValues().velocidad &&
          +form.getValues().velocidad! >= 500 && (
            <Grid
              item
              container
              spacing={2}
              {...gridSizeMdLg12}
              justifyContent={"space-between"}
            >
              <SampleCheckbox
                size={gridSizeConst5}
                label="ANDROID TV"
                control={control}
                name="es_android_tv"
                defaultValue={form.getValues().es_android_tv || false}
                onChangeValue={(e) => {
                  reset({ ...form.getValues(), es_android_tv: e });
                  if (!e)
                    reset({
                      ...form.getValues(),
                      numero_cuotas_android_tv: 0,
                      numero_cantidad_android_tv: 0,
                    });
                }}
              />
              {form.getValues().es_android_tv && (
                <>
                  <CustomAutocompleteArrString
                    label="Cant."
                    name="numero_cantidad_android_tv"
                    options={CANTIDAD_CHOICE.filter((e) => +e <= 3)}
                    control={form.control}
                    defaultValue={
                      form.getValues().numero_cantidad_android_tv || ""
                    }
                    error={errors.numero_cantidad_android_tv}
                    helperText={
                      errors.numero_cantidad_android_tv?.message?.toString() ??
                      ""
                    }
                    isLoadingData={false}
                    size={gridSizeConst3}
                  />

                  <CustomAutocompleteArrString
                    label="Cuotas"
                    name="numero_cuotas_android_tv"
                    options={CUOTAS_CHOICE.filter((e) => e == "1" || e == "6")}
                    control={form.control}
                    defaultValue={
                      form.getValues().numero_cuotas_android_tv || ""
                    }
                    error={errors.numero_cuotas_android_tv}
                    helperText={
                      errors.numero_cuotas_android_tv?.message?.toString() ??
                      ""
                    }
                    isLoadingData={false}
                    size={gridSizeConst3}
                  />

                  <Grid item {...gridSizeConst1}>
                    <IconButton
                      onClick={() => {
                        getDataProducto({
                          slug: SystemParametersEnum.ANDROID_TV,
                          cantidad:
                            form.getValues().numero_cantidad_android_tv ??
                            0,
                          cuotas:
                            form.getValues().numero_cuotas_android_tv ?? 0,
                        });
                      }}
                    >
                      <Visibility />
                    </IconButton>
                  </Grid>
                </>
              )}
            </Grid>
          )}

        <Grid item xs={12}>
          <TabTextLabel
            text={texto.observacion}
            mt={0}
            pb={0}
            pl={0}
            pt={2}
          />
        </Grid>

        <CustomTextArea
          disabled={editSupervisor}
          label={"Observación 1"}
          name="observacion_1"
          control={form.control}
          defaultValue={form.getValues().observacion_1}
          error={errors.observacion_1}
          helperText={errors.observacion_1?.message}
          required={false}
          rows={3}
        />

        <CustomTextArea
          disabled={editSupervisor}
          label={"Observación 2"}
          name="observacion_2"
          control={form.control}
          defaultValue={form.getValues().observacion_2}
          error={errors.observacion_2}
          helperText={errors.observacion_2?.message}
          required={false}
          rows={3}
        />
      </Grid>

      <ModalCuotas />
    </>

  )

}